import React from 'react';
import { Drawer, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface HelpTextPreviewDrawerProps {
  open: boolean;
  onClose: () => void;
  fieldLabel: string;
  helpText: string;
}

const HelpTextPreviewDrawer: React.FC<HelpTextPreviewDrawerProps> = ({
  open,
  onClose,
  fieldLabel,
  helpText,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          zIndex: 1150,
        },
      }}
    >
      <Box sx={{ width: 375, overflowX: 'hidden' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
            backgroundColor: 'grey.100',
          }}
        >
          <Typography
            sx={{ color: 'grey.700', fontSize: '24px', fontWeight: '500' }}
          >
            {fieldLabel}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ padding: 3 }}>
          <Typography sx={{ fontWeight: 'bold', mb: 1 }}>
            Description
          </Typography>
          <div dangerouslySetInnerHTML={{ __html: helpText || '' }} />
        </Box>
      </Box>
    </Drawer>
  );
};

export default HelpTextPreviewDrawer;
